
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1n08n_26",
  "button": "awsui_button_vjswe_1n08n_30",
  "variant-normal": "awsui_variant-normal_vjswe_1n08n_82",
  "disabled": "awsui_disabled_vjswe_1n08n_100",
  "variant-primary": "awsui_variant-primary_vjswe_1n08n_107",
  "variant-link": "awsui_variant-link_vjswe_1n08n_132",
  "variant-icon": "awsui_variant-icon_vjswe_1n08n_157",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_1n08n_182",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1n08n_209",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1n08n_234",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1n08n_259",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1n08n_288",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1n08n_313",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1n08n_338",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1n08n_368",
  "button-no-text": "awsui_button-no-text_vjswe_1n08n_481",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1n08n_485",
  "full-width": "awsui_full-width_vjswe_1n08n_488",
  "button-compact": "awsui_button-compact_vjswe_1n08n_505",
  "icon-left": "awsui_icon-left_vjswe_1n08n_535",
  "icon-right": "awsui_icon-right_vjswe_1n08n_540",
  "icon": "awsui_icon_vjswe_1n08n_535",
  "link": "awsui_link_vjswe_1n08n_559",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1n08n_559"
};
  